import { Download, Plus } from '@ufc/uikit'
import { PageHeader } from '@ufc/uikit'
import type { AddressbookHeaderProps } from '../types'

export function AddressbookHeader({
  title,
  subtitle,
  isRTL,
  onExport,
  onAdd,
  exportLabel,
  addLabel,
}: AddressbookHeaderProps) {
  return (
    <PageHeader
      title={title}
      subtitle={subtitle}
      isRTL={isRTL}
      actions={[
        {
          label: exportLabel,
          icon: Download,
          onClick: onExport,
          variant: 'outline',
        },
        {
          label: addLabel,
          icon: Plus,
          onClick: onAdd,
          primary: true,
        },
      ]}
    />
  )
}
